import { RootState } from '../../store';

export const getPhotographs = (store: RootState) => store.albums.photographs;
export const getAlbums = (store: RootState) => store.albums.albums;
export const getIsLoading = (store: RootState) => store.albums.isLoading;
